interface ProgressBarProps {
    percentage: number
    status: string
}

export default function ProgressBar({ percentage, status }: ProgressBarProps) {
    if (status === 'pending') return null

    return (
        <div className="w-full bg-gray-200 rounded-full h-3">
            <div
                className={`h-3 rounded-full transition-all duration-300 ${
                    status === 'completed' ? 'bg-green-500' :
                        status === 'failed' ? 'bg-red-500' : 'bg-blue-500'
                }`}
                style={{width: `${Math.max(percentage, 2)}%`}}
            />
        </div>
    )
}